<div class="page-caption">{{ caption }}</div>

<ng-container *ngIf="orderPaging.pages.length > 0">
  <div *ngFor="let order of orderPaging.pages[orderPaging.currentPage - 1]" class="page-order">
    <div class="page-order-head">
      <a href="javascript:void(0)" (click)="orderPreviewClick(order)"> {{ 'TITLE_ORDER_PAGE' | translate }} №{{ order.id }} </a>
      <dx-button stylingMode="text" (onClick)="goToOrder(order)">
        <img src="/assets/images/icon-open-link.png" />
      </dx-button>
    </div>
    <div [title]="order.title" class="page-order-title">
      {{ order.title | truncate: 30 }}
    </div>
    <div class="page-order-body">
      <div>{{ order.createDate | date: 'dd-MM-yyyy' }}</div>
      <dx-button (onClick)="setEstimateOrder(order)" stylingMode="text">
        {{ 'NOTIFICATIONS_ESTIMATE_FAST' | translate }}
      </dx-button>
    </div>

    <div *ngIf="estimate?.order === order" class="estimate">
      <div class="estimate-titel">{{ 'NOTIFICATIONS_ESTIMATE_FAST' | translate }}</div>
      <div class="estimate-btn">
        <dx-button (onClick)="onEstimateStarClick(estimateMark.great)">
          <!--<app-star [type]="estimateMark.great"></app-star>-->
          <svg width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
            <radialGradient
              id="a"
              cx="51.77"
              cy="31.401"
              r="87.039"
              gradientTransform="matrix(-.00218 1 -.7873 -.00172 76.604 -20.315)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".6" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#a)"
              d="M85.52 121.67c-8.63-.07-21.58-.41-34.32-1.61-8.77-.83-17.83-2.14-24.71-6.04-1.94-1.1-4.06-1.37-5.94-1.6-.8-.1-1.55-.19-2.19-.34-4.88-1.15-8.29-5.37-8.31-10.26l-.07-32.75c-.01-4.53 3.22-8.32 7.69-9.02.08-.01.15-.03.23-.05.55-.18 13.69-4.46 23.59-12.2 4.66-3.64 8.65-9.25 10.68-15 2.02-5.73 2.01-11.98 2-17 0-3.24-.01-7.27.87-7.86 2.14-1.41 4.5-2.13 7.01-2.13 7.72 0 15.6 7.05 15.91 14.23.22 4.98-1.45 10.86-3.06 16.54-1.9 6.73-3.55 12.54-2.06 16.49.22.59.78.97 1.4.97l7.29-.25h.07c8.16 0 14.8 6.64 14.81 14.79l.05 42.21c0 2.91-1.12 5.64-3.18 7.69a10.81 10.81 0 0 1-7.69 3.19h-.07z" />
            <path
              fill="#EDA600"
              d="M62.05 7.31c6.86 0 14.13 6.46 14.41 12.79.21 4.74-1.42 10.5-3 16.07-1.98 6.98-3.68 13.01-2.02 17.42a2.998 2.998 0 0 0 2.81 1.94h.11l7.2-.25h.06c7.33 0 13.3 5.96 13.31 13.3l.05 42.21c0 2.5-.97 4.86-2.74 6.63s-4.12 2.75-6.63 2.75h-.08c-8.6-.07-21.51-.41-34.19-1.6-8.6-.81-17.48-2.09-24.11-5.85-2.2-1.25-4.58-1.54-6.49-1.78-.76-.09-1.47-.18-2.03-.32-4.2-.99-7.14-4.61-7.15-8.8l-.08-32.75c-.01-3.78 2.69-6.95 6.42-7.53.15-.02.31-.06.45-.11.56-.18 13.94-4.55 24.05-12.45 4.87-3.81 9.05-9.67 11.17-15.68 2.11-5.97 2.1-12.36 2.09-17.5 0-2.44-.01-5.74.41-6.74a10.97 10.97 0 0 1 5.98-1.75m0-3c-2.65 0-5.33.72-7.84 2.38-3.24 2.14.27 15.02-3.46 25.6-2.24 6.35-6.51 11.45-10.19 14.32-9.8 7.66-23.12 11.96-23.12 11.96-5.17.81-8.97 5.27-8.96 10.51l.08 32.75c.02 5.64 3.97 10.41 9.46 11.71 2.22.52 5.25.38 7.73 1.79 6.63 3.76 15.13 5.26 25.31 6.22 12.6 1.19 25.4 1.54 34.45 1.62h.1c6.83 0 12.38-5.54 12.37-12.38l-.05-42.21c-.01-9.01-7.32-16.29-16.31-16.29h-.12l-7.24.25c-2.5-6.64 5.69-21.58 5.21-32.57-.35-7.81-8.68-15.66-17.42-15.66z" />
            <path
              fill="#EDA600"
              d="M66.12 62.5c1.88 5 1.9 12.8 0 17.62-2.75 6.96-9.48 13.05-17.25 14.12-1.9.26-.77 2.01 1.12 1.75 8.41-1.16 19.79-4.57 22.75-12.12 8.12-20.75-1.38-31.62-5.62-28.38-2.04 1.58-2.06 4.18-1 7.01z" />
            <radialGradient
              id="b"
              cx="2459.4"
              cy="-319.18"
              r="20.331"
              gradientTransform="matrix(-1.3883 .0794 -.0374 -.6794 3505.4 -353.39)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#b)"
              d="M86.28 69.92c-8.36 0-18.41-1.55-18.84-8.96-.12-2.12.52-3.9 1.96-5.43 3.79-4.02 13.1-6.23 26.22-6.23 4.76 0 8.23.31 8.27.31s.09.01.13.01h.09c.14-.01.27-.01.41-.01 4.25 0 7.8 3.83 8.09 8.72.3 5.06-3.03 9.38-7.42 9.63-.07 0-.15.01-.22.03-.09.01-9.35 1.93-18.69 1.93z" />
            <path
              fill="#EDA600"
              d="M95.63 50.8c4.68 0 8.1.3 8.13.3.09.01.18.01.27.01.06 0 .12 0 .17-.01.11-.01.22-.01.32-.01 3.45 0 6.35 3.21 6.59 7.3.12 2.12-.48 4.13-1.69 5.67-1.13 1.44-2.67 2.28-4.32 2.38-.15.01-.3.03-.44.06-.09.02-9.22 1.91-18.38 1.91-5.32 0-9.54-.62-12.53-1.84-4.11-1.68-4.72-4.06-4.81-5.7-.1-1.71.4-3.08 1.56-4.32 3.45-3.65 12.61-5.75 25.13-5.75m0-3c-11.42 0-30.36 1.73-29.69 13.25.49 8.32 10.53 10.37 20.34 10.37 9.61 0 19-1.97 19-1.97 5.22-.31 9.18-5.33 8.83-11.22-.33-5.7-4.57-10.13-9.58-10.13-.17 0-.33 0-.5.01 0 0-3.51-.31-8.4-.31z" />
            <radialGradient
              id="c"
              cx="2557.2"
              cy="-508.52"
              r="18.753"
              gradientTransform="matrix(-1.6967 -.00188 .00291 -.6804 4447.7 -263.06)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#c)"
              d="M92.55 88.95c-10.91 0-23.91-1.83-23.91-10.57s13-10.57 23.91-10.57c9.25 0 17.68 1.35 17.76 1.36s.16.02.24.02c4.41 0 7.48 4.66 7.48 8.84 0 4.41-3.27 9.53-7.48 9.53-.08 0-.16.01-.24.02-.09.02-8.52 1.37-17.76 1.37z" />
            <path
              fill="#EDA600"
              d="M92.55 69.32c9.12 0 17.44 1.33 17.52 1.34.16.03.32.04.48.04 3.42 0 5.98 3.88 5.98 7.34 0 3.61-2.76 8.03-5.98 8.03-.16 0-.32.01-.48.04-.08.01-8.41 1.34-17.52 1.34-6.83 0-12.26-.72-16.15-2.15-5.61-2.06-6.26-4.94-6.26-6.92 0-1.99.65-4.86 6.26-6.92 3.88-1.42 9.32-2.14 16.15-2.14m0-3c-11.93 0-25.41 2.19-25.41 12.07s13.47 12.07 25.41 12.07c9.49 0 18-1.38 18-1.38 5.16 0 8.98-5.91 8.98-11.03s-3.82-10.34-8.98-10.34c0-.01-8.52-1.39-18-1.39z" />
            <radialGradient
              id="d"
              cx="2601.3"
              cy="-320.21"
              r="20.446"
              gradientTransform="matrix(-1.3069 -.00626 .00452 -.6804 3502.3 -88.992)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#d)"
              d="M100.86 122.19c-4.21 0-25.54-.33-32-6.8-1.13-1.13-1.67-2.35-1.67-3.73.02-5.25 9.01-8.26 24.66-8.26 5.58 0 9.9.4 9.95.4.04 0 .09.01.13.01 2.34.01 4.55.96 6.2 2.69 1.67 1.74 2.58 4.06 2.58 6.52-.02 5.05-3.97 9.15-8.81 9.15-.07.02-.42.02-1.04.02z" />
            <path
              fill="#EDA600"
              d="M91.86 104.91c5.49 0 9.76.39 9.8.4.09.01.18.01.27.01 1.93.01 3.75.8 5.12 2.23 1.4 1.46 2.17 3.41 2.16 5.48-.01 4.22-3.29 7.66-7.34 7.66h-.07c-.02 0-.36.01-.95.01-18.15 0-28.01-3.43-30.94-6.36-1.11-1.11-1.23-2.05-1.23-2.66.03-4.18 8.9-6.77 23.18-6.77m0-3c-10.72 0-26.14 1.44-26.16 9.75-.04 11.46 29.3 12.03 35.16 12.03.65 0 1.01-.01 1.01-.01h.03c5.68 0 10.29-4.76 10.31-10.65.02-5.9-4.58-10.7-10.27-10.72 0 .01-4.37-.4-10.08-.4z" />
            <radialGradient
              id="e"
              cx="2578.2"
              cy="-485.68"
              r="18.611"
              gradientTransform="matrix(-1.6358 -.00188 .0028 -.6804 4323.8 -229.31)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#e)"
              d="M97.12 106.32c-8.99 0-29.89-1.02-29.89-10.47 0-7.94 15.07-9.12 24.06-9.12 7.95 0 14.8.88 14.87.89.06.01.13.01.19.01 4.17 0 9.03 2.06 9.03 7.87 0 5.5-4.3 10.5-9.03 10.5h-.12c-.04.01-3.89.32-9.11.32z" />
            <path
              fill="#EDA600"
              d="M91.29 85.24v3c7.83 0 14.61.87 14.67.88.13.02.26.02.39.02 3.64 0 7.53 1.67 7.53 6.37 0 4.63-3.66 9-7.53 9-.08 0-.16 0-.25.01-.04 0-3.83.31-8.99.31-5.45 0-13.24-.35-19.41-1.99-5.95-1.59-8.97-3.94-8.97-6.97 0-.93 0-3.76 6.34-5.75 3.95-1.24 9.4-1.87 16.21-1.87l.01-3.01m0 0c-11.56 0-25.56 1.82-25.56 10.62 0 10.37 19.4 11.97 31.39 11.97 5.36 0 9.23-.32 9.23-.32 5.64 0 10.53-5.83 10.53-12s-4.89-9.37-10.53-9.37c0 0-6.93-.9-15.06-.9zm-63.5 29.66L23 96l-2 17z" />
          </svg>
          <span>{{ 'NOTIFICATIONS_ESTIMATE_GOOD' | translate }}</span>
        </dx-button>
        <dx-button (onClick)="onEstimateStarClick(estimateMark.fine)">
          <!--<app-star [type]="estimateMark.fine"></app-star>-->
          <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 128 128">
            <radialGradient id="a" cx="36.981" cy="25.583" r="18.809" gradientUnits="userSpaceOnUse">
              <stop offset=".279" stop-color="#FFCA28" />
              <stop offset=".797" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#a)"
              d="M77.93 56.52c-9.51 0-29.16-15.9-30.35-16.87-2.3-2.31-7.18-8.29-4.28-14.92.62-1.43 1.97-2.15 3.99-2.15 2.45 0 5.62 1.11 8.47 2.97l25.49 19.69c1.44 1.09 2.12 2.61 2.01 4.53-.1 1.81-.92 3.87-2.27 5.65-.66.74-1.66 1.1-3.06 1.1z" />
            <path
              fill="#EDA600"
              d="M47.29 24.07c2.16 0 5 1 7.6 2.69l25.46 19.68c1.02.77 1.48 1.83 1.4 3.24-.08 1.5-.78 3.24-1.93 4.78-.18.19-.65.56-1.91.56-7.6 0-23.63-11.81-29.33-16.48-2.1-2.13-6.43-7.47-3.92-13.21.18-.38.57-1.26 2.63-1.26m0-3c-2.43 0-4.42.91-5.36 3.05-2.71 6.19.39 12.38 4.64 16.64 0 0 20.94 17.26 31.35 17.26 1.76 0 3.22-.5 4.23-1.65 2.98-3.94 3.95-9.34.01-12.32L56.63 24.31c-3.03-1.99-6.48-3.24-9.34-3.24z" />
            <radialGradient id="b" cx="61.362" cy="24.895" r="36.22" fx="53.02" fy="33.761" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#b)"
              d="M96.48 89.21c-9.3-.1-12.3-20.27-12.67-28.05a1.49 1.49 0 0 0-.6-1.13c-4.29-3.23-9.09-14.19-12.15-23.38-.09-.26-.15-.39-.16-.4-.19-.34-.5-.6-.88-.72-6.87-2.11-17.35-10.65-21.54-15.59-2.31-2.72-3.79-8.49-2.24-11.83.75-1.62 2.09-2.4 4.1-2.4 2.54 0 6.04 1.3 10.13 3.77 1.14.83 20.68 15.09 25.8 20.76 5.21 5.77 11.64 18.63 11.7 18.76 8.25 17.42 7.04 33.11 6.63 36.67-3.42 1.64-7.27 3.36-8.12 3.54z" />
            <path
              fill="#EDA600"
              d="M50.35 7.21c1.57 0 4.46.61 9.3 3.52 1.57 1.14 20.57 15.02 25.52 20.51 4.97 5.5 11.14 17.78 11.46 18.4 7.54 15.95 7 30.45 6.58 35.03-2.87 1.36-5.91 2.71-6.9 3.02-7.34-.4-10.57-18.03-10.99-26.61-.04-.89-.48-1.72-1.19-2.26-2.51-1.89-7.07-8.96-11.63-22.65-.08-.24-.14-.41-.27-.65-.38-.69-1-1.2-1.75-1.43-3.01-.93-7.1-3.29-11.53-6.66-3.65-2.78-7.31-6.11-9.31-8.47-2.21-2.6-3.21-7.67-2.03-10.23.35-.75.95-1.52 2.74-1.52m0-3c-8.45 0-7.13 11.84-3 16.7 3.98 4.69 14.7 13.73 22.25 16.06.04.07 6.19 19.34 12.72 24.26 0 0 1.4 29.48 14.24 29.48 1.12 0 9.44-4.04 9.44-4.04s3-17.92-6.67-38.33c0 0-6.51-13.1-11.93-19.1s-26.09-21-26.09-21c-4.75-2.88-8.33-4.03-10.96-4.03z" />
            <defs>
              <path
                id="c"
                d="M97.28 72.46c-4.15-7.82-8.62-21.08-14.15-22.92l-21.91-6.88c-3.01-1-11.08 1.58-15.19 3.52-.35.12-18.48 12.77-18.48 12.77-4.31 2.71-6.14 8.27-1.64 11.41 5.54 3.87 10.67 4.26 15.81 2.13s8.83-6.77 13.34-8.51 12.11-.98 16.01 4.24 5.94 21.24-8.01 27.08c-14.78 6.19-22.64-14.2-22.64-14.2-2.46-4.45-7.4-8.02-12.93-6.19-5.54 1.83-5.97 5.93-5.91 11.95 0 0 1.25 12.89 5.97 19.47s13.92 13.11 13.92 13.11c.76.73 6.99 4.34 9.79 4.36l19.61-.03c11.73-.02 22.33-6.63 26.91-16.81 3.53-7.86 7.11-16.33 7.99-20.17.59-2.58-3.03-2.29-3.03-2.29s-1.31-4.22-5.46-12.04z" />
            </defs>
            <clipPath id="d"><use xlink:href="#c" /></clipPath>
            <g clip-path="url(#d)">
              <radialGradient
                id="e"
                cx="119.42"
                cy="60.56"
                r="58.828"
                gradientTransform="matrix(1.0612 0 0 1 -73.68 0)"
                gradientUnits="userSpaceOnUse">
                <stop offset=".242" stop-color="#FFCA28" />
                <stop offset=".797" stop-color="#FFB300" />
              </radialGradient>
              <path
                fill="url(#e)"
                d="M51.27 122.3c-2.26-.02-7.98-3.25-8.77-3.94-.04-.04-.12-.1-.16-.13-.09-.06-9.05-6.47-13.57-12.77-4.44-6.18-5.87-18.29-5.88-18.41-.57-3.96-.14-8.98 5.07-10.71.83-.28 1.67-.42 2.51-.42 3.92 0 7 2.99 8.6 5.82.6 1.51 6.77 16.23 18.52 16.23 1.98 0 4.02-.43 6.06-1.29 7.19-3.01 9.99-8.36 11.07-12.32 1.79-6.55.08-13.67-2.44-17.04-2.66-3.57-7.28-5.7-12.34-5.7-1.95 0-3.83.32-5.42.94-2.43.94-4.62 2.63-6.74 4.26-2.08 1.6-4.23 3.26-6.64 4.26-1.9.79-3.7 1.17-5.51 1.17-2.94 0-5.84-1.03-8.87-3.14-1.34-.93-2-2.12-1.96-3.53.05-1.94 1.44-4.06 3.55-5.38 6.92-4.83 17.37-12.09 18.36-12.7 3.32-1.55 8.56-2.82 11.7-2.82.98 0 1.53.12 1.82.21l21.55 7c4.58 1.53 11.44 12.15 14.74 17.26l.91 1.4c.06.09.12.17.19.24.08.08 8.32 8.44 6.68 15.66-.7 3.08-3.43 9.96-7.89 19.88-4.34 9.66-14.37 15.91-25.54 15.92l-19.6.05z" />
              <path
                fill="#EDA600"
                d="M58.41 46.19c.87 0 1.25.11 1.37.14l21.51 6.99c4.09 1.36 11.01 12.08 13.97 16.65.33.51.63.98.91 1.41.11.17.24.34.39.48 2.16 2.16 7.49 8.92 6.27 14.26-.47 2.08-2.21 7.17-7.8 19.6-4.1 9.12-13.59 15.02-24.18 15.04l-19.58.03c-1.57-.01-6.67-2.69-7.8-3.58-.09-.08-.18-.16-.28-.22-.09-.06-8.84-6.32-13.22-12.42-4.2-5.86-5.59-17.59-5.61-17.71 0-.03-.01-.06-.01-.09-.7-4.87.67-7.91 4.06-9.03.68-.23 1.36-.34 2.04-.34 3.24 0 5.85 2.54 7.24 4.98.85 2.09 7.38 17.07 19.88 17.07 2.18 0 4.42-.47 6.64-1.4 7.75-3.24 10.76-9.03 11.93-13.31 1.93-7.09.11-14.59-2.68-18.33-2.94-3.94-8.01-6.3-13.54-6.3-2.13 0-4.19.36-5.95 1.04-2.64 1.02-4.91 2.77-7.12 4.47-2.09 1.62-4.07 3.14-6.3 4.07-1.71.71-3.33 1.06-4.93 1.06-2.62 0-5.24-.94-8.01-2.87-.91-.64-1.35-1.38-1.32-2.27.03-1.43 1.18-3.1 2.85-4.15.04-.03.08-.05.12-.08 6.4-4.47 16.8-11.7 18.16-12.57 3.12-1.42 8.11-2.62 10.99-2.62m0-3c-3.61 0-9.1 1.43-12.39 2.98-.35.12-18.48 12.77-18.48 12.77-4.31 2.71-6.14 8.27-1.64 11.41 3.36 2.35 6.57 3.41 9.73 3.41 2.04 0 4.06-.45 6.08-1.28 5.13-2.13 8.83-6.77 13.34-8.51 1.4-.54 3.09-.84 4.87-.84 3.99 0 8.44 1.48 11.14 5.09 3.9 5.22 5.94 21.24-8.01 27.08-1.95.82-3.78 1.17-5.48 1.17-11.24 0-17.16-15.37-17.16-15.37-2.01-3.63-5.67-6.68-9.95-6.68-.96 0-1.96.15-2.98.49-5.54 1.83-6.85 6.98-6.09 12.3 0 0 1.43 12.54 6.15 19.12s13.92 13.11 13.92 13.11c.76.73 6.99 4.34 9.79 4.36l19.61-.03c11.73-.02 22.33-6.63 26.91-16.81 3.53-7.86 7.11-16.33 7.99-20.17 1.85-8.12-7.08-17.05-7.08-17.05-3.46-5.3-10.91-17.42-16.44-19.26l-21.53-7c-.6-.2-1.39-.29-2.3-.29z" />
            </g>
          </svg>
          <span>{{ 'NOTIFICATIONS_ESTIMATE_OK' | translate }}</span>
        </dx-button>
        <dx-button (onClick)="onEstimateStarClick(estimateMark.bad)">
          <!--<app-star [type]="estimateMark.bad"></app-star>-->
          <svg width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
            <radialGradient
              id="a"
              cx="51.77"
              cy="31.401"
              r="87.039"
              gradientTransform="matrix(-.00218 -1 -.7873 .00172 76.604 148.32)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".6" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#a)"
              d="M62.05 122.19c-2.51 0-4.87-.72-7.01-2.13-.88-.58-.88-4.62-.87-7.86.01-5.02.02-11.27-2-16.99-2.03-5.75-6.03-11.36-10.68-15-9.9-7.74-23.03-12.02-23.59-12.2-.07-.02-.15-.04-.23-.05a9.05 9.05 0 0 1-7.69-9.02l.08-32.75c.01-4.89 3.43-9.1 8.31-10.26.63-.15 1.39-.24 2.19-.34 1.87-.23 3.99-.5 5.94-1.6 6.88-3.9 15.94-5.21 24.71-6.04 12.74-1.2 25.69-1.54 34.32-1.61 3 0 5.73 1.13 7.78 3.19 2.05 2.05 3.18 4.79 3.18 7.69l-.05 42.21c-.01 8.16-6.66 14.79-14.81 14.79h-.13l-7.25-.25c-.62 0-1.18.39-1.4.97-1.49 3.95.16 9.76 2.06 16.49 1.61 5.69 3.27 11.57 3.06 16.54-.32 7.18-8.2 14.22-15.92 14.22z" />
            <path
              fill="#EDA600"
              d="M85.61 7.83c2.51 0 4.86.98 6.63 2.75s2.74 4.12 2.74 6.63l-.05 42.21c-.01 7.33-5.98 13.3-13.31 13.3h-.06l-7.2-.25h-.11c-1.24 0-2.37.77-2.81 1.94-1.66 4.41.04 10.44 2.02 17.42 1.58 5.57 3.21 11.34 3 16.07-.28 6.34-7.55 12.79-14.41 12.79-2.13 0-4.14-.59-5.97-1.75-.42-1-.41-4.3-.41-6.74.01-5.13.02-11.52-2.09-17.5-2.12-6.01-6.3-11.88-11.17-15.68-10.11-7.9-23.49-12.27-24.05-12.45-.15-.05-.3-.08-.45-.11-3.73-.59-6.44-3.76-6.42-7.54l.08-32.75c.01-4.19 2.95-7.81 7.15-8.8.56-.13 1.27-.22 2.03-.32 1.91-.24 4.29-.54 6.49-1.78 6.64-3.76 15.51-5.03 24.11-5.85 12.68-1.2 25.59-1.53 34.19-1.6l.07.01m0-3h-.1c-9.04.07-21.85.43-34.45 1.62-10.18.96-18.68 2.47-25.31 6.22-2.48 1.41-5.51 1.26-7.73 1.79-5.49 1.3-9.44 6.07-9.46 11.71l-.08 32.76c-.02 5.23 3.79 9.7 8.96 10.51 0 0 13.32 4.29 23.12 11.96 3.68 2.87 7.95 7.97 10.19 14.32 3.74 10.58.23 23.46 3.46 25.6 2.51 1.66 5.19 2.38 7.84 2.38 8.74 0 17.07-7.86 17.41-15.66.48-10.99-7.71-25.93-5.21-32.57l7.24.25h.12c8.99 0 16.3-7.29 16.31-16.29l.05-42.21c.02-6.85-5.53-12.39-12.36-12.39z" />
            <path
              fill="#EDA600"
              d="M66.12 65.5c1.88-5 1.9-12.8 0-17.62-2.75-6.96-9.48-13.05-17.25-14.12-1.9-.26-.77-2.01 1.12-1.75 8.41 1.16 19.79 4.57 22.75 12.12 8.12 20.75-1.38 31.62-5.62 28.38-2.04-1.58-2.06-4.18-1-7.01z" />
            <radialGradient
              id="b"
              cx="2621.1"
              cy="-453.3"
              r="20.331"
              gradientTransform="matrix(-1.3883 -.0794 -.0374 .6794 3724.9 585.35)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#b)"
              d="M95.63 78.7c-13.12 0-22.44-2.21-26.22-6.23-1.45-1.53-2.09-3.31-1.96-5.43.43-7.41 10.49-8.96 18.84-8.96 9.34 0 18.6 1.92 18.69 1.94.07.02.15.03.22.03 4.39.26 7.72 4.58 7.42 9.63-.29 4.89-3.84 8.72-8.09 8.72-.14 0-.27 0-.41-.01h-.09c-.04 0-.09 0-.13.01-.04-.01-3.51.3-8.27.3z" />
            <path
              fill="#EDA600"
              d="M86.28 59.58c9.16 0 18.29 1.89 18.38 1.91.14.03.29.05.44.06 1.66.1 3.19.94 4.32 2.38 1.21 1.54 1.81 3.56 1.69 5.67-.24 4.09-3.13 7.3-6.59 7.3-.11 0-.22 0-.32-.01-.06 0-.12-.01-.17-.01-.09 0-.18 0-.27.01-.03 0-3.45.3-8.13.3-12.52 0-21.68-2.1-25.13-5.76-1.16-1.23-1.66-2.61-1.56-4.32.1-1.64.7-4.02 4.81-5.7 3-1.21 7.21-1.83 12.53-1.83m0-3c-9.81 0-19.85 2.06-20.34 10.37-.67 11.52 18.27 13.25 29.69 13.25 4.89 0 8.4-.32 8.4-.32.17.01.33.01.5.01 5.01 0 9.25-4.42 9.58-10.13.34-5.89-3.61-10.91-8.83-11.22 0 .01-9.39-1.96-19-1.96z" />
            <radialGradient
              id="c"
              cx="2719.2"
              cy="-648.52"
              r="18.753"
              gradientTransform="matrix(-1.6967 .00188 .00291 .6804 4723 486.01)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#c)"
              d="M92.55 60.18c-10.91 0-23.91-1.83-23.91-10.57 0-8.73 13-10.57 23.91-10.57 9.26 0 17.68 1.35 17.76 1.36s.16.02.24.02c4.21 0 7.48 5.12 7.48 9.53 0 4.18-3.07 8.84-7.48 8.84-.08 0-.16.01-.24.02-.09.02-8.51 1.37-17.76 1.37z" />
            <path
              fill="#EDA600"
              d="M92.55 40.55c9.12 0 17.44 1.33 17.52 1.34.16.03.32.04.48.04 3.22 0 5.98 4.41 5.98 8.03 0 3.47-2.56 7.34-5.98 7.34-.16 0-.32.01-.48.04-.08.01-8.38 1.34-17.52 1.34-6.83 0-12.26-.72-16.15-2.15-5.61-2.06-6.26-4.94-6.26-6.92 0-1.99.65-4.86 6.26-6.92 3.88-1.42 9.32-2.14 16.15-2.14m0-3c-11.93 0-25.41 2.19-25.41 12.07s13.47 12.07 25.41 12.07c9.49 0 18-1.38 18-1.38 5.16 0 8.98-5.23 8.98-10.34s-3.82-11.03-8.98-11.03c0-.01-8.52-1.39-18-1.39z" />
            <radialGradient
              id="d"
              cx="2763.2"
              cy="-460.57"
              r="20.446"
              gradientTransform="matrix(-1.3069 .00626 .00452 .6804 3714.6 311.48)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#d)"
              d="M91.85 24.59c-15.66 0-24.64-3.01-24.66-8.26 0-1.38.54-2.6 1.67-3.73 6.45-6.47 27.79-6.8 32-6.8.62 0 .98.01.98.01 4.91 0 8.86 4.11 8.88 9.15.01 2.46-.91 4.78-2.58 6.52-1.66 1.73-3.86 2.68-6.2 2.69-.04 0-.09 0-.13.01-.05.01-4.39.41-9.96.41z" />
            <path
              fill="#EDA600"
              d="M100.86 7.31c.6 0 .94.01.95.01h.09c4.02 0 7.3 3.44 7.31 7.66.01 2.07-.76 4.02-2.16 5.48-1.37 1.43-3.19 2.22-5.12 2.23-.09 0-.18 0-.27.01-.04 0-4.3.4-9.8.4-14.27 0-23.15-2.59-23.16-6.76 0-.61.12-1.55 1.23-2.66 2.92-2.95 12.77-6.37 30.93-6.37m0-3c-5.86 0-35.2.57-35.16 12.03.03 8.31 15.45 9.75 26.16 9.75 5.71 0 10.08-.41 10.08-.41 5.69-.02 10.29-4.82 10.27-10.72-.02-5.89-4.63-10.65-10.31-10.65h-1.04z" />
            <radialGradient
              id="e"
              cx="2740.2"
              cy="-625.68"
              r="18.611"
              gradientTransform="matrix(-1.6358 .00188 .0028 .6804 4589.2 452.27)"
              gradientUnits="userSpaceOnUse">
              <stop offset=".599" stop-color="#FFCA28" />
              <stop offset="1" stop-color="#FFB300" />
            </radialGradient>
            <path
              fill="url(#e)"
              d="M91.29 41.26c-8.98 0-24.06-1.19-24.06-9.12 0-9.45 20.9-10.47 29.89-10.47 5.23 0 9.07.31 9.11.31h.12c4.73 0 9.03 5 9.03 10.5 0 5.81-4.87 7.87-9.03 7.87-.06 0-.13 0-.19.01-.07.03-6.94.9-14.87.9z" />
            <path
              fill="#EDA600"
              d="M97.12 23.18c5.15 0 8.95.31 8.99.31.08.01.16.01.25.01 3.87 0 7.53 4.37 7.53 9 0 4.7-3.89 6.37-7.53 6.37-.13 0-.26.01-.39.02-.07.01-6.85.88-14.68.88-6.81 0-12.27-.63-16.21-1.87-6.34-2-6.34-4.82-6.34-5.75 0-3.04 3.02-5.38 8.97-6.97 6.16-1.66 13.96-2 19.41-2m0-3c-11.99 0-31.39 1.6-31.39 11.97 0 8.8 14 10.62 25.56 10.62 8.13 0 15.06-.9 15.06-.9 5.64 0 10.53-3.2 10.53-9.37s-4.89-12-10.53-12c0 0-3.88-.32-9.23-.32zM27.79 13.1 23 32l-2-17z" />
          </svg>
          <span>{{ 'NOTIFICATIONS_ESTIMATE_BAD' | translate }}</span>
        </dx-button>
      </div>

      <div *ngIf="estimate.estimateMark" class="estimate-body">
        <div>{{ 'NOTIFICATIONS_ESTIMATE_THANK' | translate }}</div>

        <ng-container [ngSwitch]="estimate.estimateMark">
          <div *ngSwitchCase="estimateMark.bad">
            {{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD' | translate }}
            <div *ngIf="getCheckedText() == ''" style="color: red">
              {{ 'FIELD_IS_REQUIRED' | translate }}
            </div>
            <div style="text-align: left">
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD1' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD2' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD3' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD4' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD5' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD6' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD7' | translate }}"
                [value]="false"></dx-check-box>
              <dx-check-box
                class="bad-box"
                style="font-size: 12px"
                text="{{ 'NOTIFICATIONS_ESTIMATE_MARK_BAD8' | translate }}"
                [value]="false"
                (onValueChanged)="checkOtherCommentToggled($event)"></dx-check-box>
            </div>
          </div>
          <div *ngSwitchCase="estimateMark.fine">
            {{ 'NOTIFICATIONS_ESTIMATE_MARK_FINE' | translate }}
          </div>
          <div *ngSwitchCase="estimateMark.great">
            {{ 'NOTIFICATIONS_ESTIMATE_MARK_GREAT' | translate }}
          </div>
        </ng-container>

        <dx-text-box
          *ngIf="estimate.estimateMark == estimateMark.fine || otherComment"
          [(value)]="estimate.comment"
          placeholder="{{ 'NOTIFICATIONS_ESTIMATE_NOTE' | translate }}"
          [maxLength]="100">
          <dx-validator *ngIf="otherComment">
            <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>

        <div>
          <dx-button (onClick)="sendEstimate($event)">
            {{ 'NOTIFICATIONS_ESTIMATE_CONFIRM' | translate }}
          </dx-button>
          <dx-button (onClick)="clearEstimate()">
            {{ 'NOTIFICATIONS_ESTIMATE_CLOSE' | translate }}
          </dx-button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="orderPaging.pages.length > 1" class="page-btn">
    <dx-button [disabled]="!(orderPaging.currentPage > 1)" (onClick)="nextPage(false)"><</dx-button>
    <div>{{ orderPaging.currentPage }}/{{ orderPaging.pages.length }}</div>
    <dx-button [disabled]="!(orderPaging.currentPage < orderPaging.pages.length)" (onClick)="nextPage(true)"> > </dx-button>
  </div>
</ng-container>

<div *ngIf="orderPreview.isShow" class="order-preview">
  <div class="order-preview-btns">
    <div (click)="goToOrder(orderPreview.order)">
      <img src="/assets/images/icon-open-link-black.png" />
    </div>

    <div (click)="hideOrderPreview()">
      <img src="/assets/images/icon_close_arrow.png" />
    </div>
  </div>

  <app-order-preview [order]="orderPreview.order"></app-order-preview>
  <div></div>
</div>
